import { AccountObject } from "./account-object.model";
import { IAclFilter } from "../../store/queries/acl-filter.interface";
import { dictionarySelector, listSelector } from "../query-facade";
import { createSelector } from "reselect";
import { AclFilter } from "../../store/queries/acl-filter";
import { AppConfig } from "../../../app/app.config";

export class AccountObjectAclFilter<T extends AccountObject> extends AclFilter<AccountObject> implements IAclFilter<T> {

    createSelector(idsSelector: listSelector<string>, entitiesSelector: dictionarySelector<T>): listSelector<T> {
        return createSelector(
            idsSelector,
            entitiesSelector,
            this.activeUserMembershipsByAccount,
            this.isAccountOwnerByAccount,
            this.selectedUser,
            (ids, entities, activeUserMembershipsByAccount, isAccountOwnerByAccount, user) => {
                AppConfig.debugQueries && console.log("AccountObjectAclFilter executing", entities);
                return ids
                    .map(id => entities[id])
                    .filter(item => {

                        const membership = activeUserMembershipsByAccount[item.account];
                        const isOwner = isAccountOwnerByAccount[item.account];

                        if (!membership) {
                            return false;
                        }

                        if (isOwner || membership.admin) {
                            return true;
                        }

                        return this.customChecks.length === this.customChecks
                            .filter(check => check.hasAccess(item, membership, user))
                            .length;
                    });
            }
        );
    }
}



// WEBPACK FOOTER //
// ./src/vas/business-objects/account-object/account-object.acl-filter.ts